import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { LocationData } from "../../data/footerData";
import { FaBell, FaBellSlash } from "react-icons/fa";
import ConfirmLocationModal from "./ConfirmLocationModal";

const PageWrapper = styled.div`
  min-height: 70vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0rem 0rem;
  background: url("/black-paper-3.jpg");
  background-size: cover;
`;

const Heading = styled.h2`
  font-size: clamp(1.8rem, 6vw, 2.5rem);
  font-weight: 700;
  text-align: center;
  margin-bottom: 1.5rem;
  background: -webkit-linear-gradient(135deg, #fed693, #ca7100);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const ListContainer = styled.div`
  background: #1c1c1c;
  border-radius: 16px;
  padding: 0.5rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.7);
  width: 95%;
  max-width: 420px;
`;

const ListItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px;
  border-bottom: 1px solid #333;

  &:last-child {
    border-bottom: none;
  }
`;

const Left = styled.div`
  display: flex;
  align-items: start;
  gap: 12px;
  margin-left: 0px; /* adds horizontal breathing room */
  margin-right: 5px;
  margin-top: 6px; /* pushes button slightly lower */
`;

const Img = styled.img`
  margin-top: 6px;
  width: 52px;
  height: 52px;
  border-radius: 12px;
  object-fit: cover;
  border: 1px solid #fed693;
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 220px;
  margin-right: 12px; /* gap between text and button */
`;

const Title = styled.span`
  font-size: 0.95rem;
  font-weight: 600;
  color: #fff;
`;

const SubTitle = styled.span`
  font-size: 0.85rem;
  font-weight: 400;
  color: #bbb;
`;

const Address = styled.a`
  font-size: 0.75rem;
  font-weight: 400;
  color: #aaa;
  margin-top: 2px;
  line-height: 1.2;
  text-decoration: none;

  &:hover {
    color: #fed693;
    text-decoration: underline;
  }
`;

const Status = styled.span`
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 2px;
  color: ${({ open }) => (open ? "#4ade80" : "#f87171")};
`;

const Right = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const BookButton = styled.button`
  background: linear-gradient(-45deg, #fed693, #ca7100);
  border: none;
  width: 90px;
  height: 32px;
  border-radius: 8px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  text-align: center;

  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(202, 113, 0, 0.5);
  }
`;

function getStatus(location) {
  const now = new Date();
  const currentDay = now.getDay();
  const currentHour = now.getHours();

  let openingHour = 9;
  let closingHour = 18;

  if (currentDay === 0) {
    if (location.town === "KAIKOURA") {
      openingHour = 12;
      closingHour = 16;
    } else if (location.town === "PICTON") {
      openingHour = 11.75; // 11:45
      closingHour = 16;
    }
  }

  if (currentHour >= openingHour && currentHour < closingHour) {
    return { open: true, text: `Open until ${closingHour}:00` };
  } else {
    return {
      open: false,
      text: `Closed · Opens at ${
        openingHour === 11.75 ? "11:45" : openingHour + ":00"
      }`,
    };
  }
}

export default function LocationMobileList() {
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);

  useEffect(() => {
    setLocations(
      LocationData.map((loc) => ({
        ...loc,
        status: getStatus(loc),
      }))
    );
  }, []);

  return (
    <PageWrapper>
      <ListContainer>
        {locations.map((loc, index) => (
          <ListItem key={index}>
            <Left>
              <Img src={loc.img} alt={loc.town} />
              <Info>
                <Title>{loc.town}</Title>
                <SubTitle>{loc.title}</SubTitle>
                {/* ✅ show address from links[0], clickable to Google Maps */}
                {loc.links && loc.links[0] && (
                  <Address
                    href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                      loc.links[0]
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {loc.links[0]}
                  </Address>
                )}
                <Status open={loc.status.open}>
                  {loc.status.open ? <FaBell /> : <FaBellSlash />}
                  {loc.status.text}
                </Status>
              </Info>
            </Left>
            <Right>
              <BookButton onClick={() => setSelectedLocation(loc)}>
                BOOK NOW
              </BookButton>
            </Right>
          </ListItem>
        ))}
      </ListContainer>
      <ConfirmLocationModal
        location={selectedLocation}
        onCancel={() => setSelectedLocation(null)}
        onConfirm={(loc) => {
          setSelectedLocation(null);
          window.open(loc.fresha, "_blank"); // ✅ open in new tab after confirm
        }}
      />
    </PageWrapper>
  );
}
